export default {
  breakpoints: [768, 1024, 2000],
  space: [0, 4, 8, 16, 25, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 36, 48, 80, 96],
  fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5
  },
  letterSpacings: {
    normal: "normal",
    tracked: "0.1em",
    tight: "-0.05em",
    mega: "0.25em"
  },
  fonts: {
    serif: "athelas, georgia, times, serif",
    sansSerif:
      '-apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif'
  },
  borders: [
    0,
    "1px solid",
    "2px solid",
    "4px solid",
    "8px solid",
    "16px solid",
    "32px solid"
  ],
  shadows: [
    'none',
    '1px 1px 4px rgba(0,0,0,0.3)'
  ],
  radii: [0, 2, 4, 16, 9999, "100%"],
  width: [16, 32, 64, 128, 256],
  heights: [16, 32, 64, 128, 256],
  maxWidths: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  colors: {
    rojoBac: 'rgb(228,0,43)',
    rojoClaro: 'rgb(200,16,46)',
    rojoMedio: 'rgb(166,25,46)',
    rojoOscuro: 'rgb(118,35,47)',
    grisDeFondo: 'rgb(241,242,242)',
    grisClaro: 'rgb(230,230,230)',
    grisMedio: 'rgb(190,190,190)',
    grisOscuro: 'rgb(109,110,113)',
    grisExtraOscuro: 'rgb(77,77,79)',
    blanco: 'rgb(255,255,255)',
    negro: 'rgb(0,0,0)',
    amexBlue: 'rgb(0,110,194)',
    amexGrisFondo: 'rgb(224,226,227)',
    amexGrisTexto: 'rgb(82,85,89)',
    amexAzulOscuro: 'rgb(1,23,90)',
  }
};